import { Link } from 'react-router-dom';
import { Search, Home } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] text-center">
      <h1 className="text-9xl font-bold text-gray-200">404</h1>
      <h2 className="text-2xl font-semibold text-gray-900 mt-4">Page Not Found</h2>
      <p className="text-gray-500 mt-2 max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div className="flex gap-4 mt-6">
        <Link to="/" className="btn-primary">
          <Home className="h-4 w-4 mr-2" />
          Go Home
        </Link>
        <Link to="/search" className="btn-secondary">
          <Search className="h-4 w-4 mr-2" />
          Search Institutions
        </Link>
      </div>
    </div>
  );
}
